import React from 'react';

const Home = () => (
  <div id="home-page">
    <h2 id="home-header">Welcome to our page</h2>
    <p id="home-text">
      Mathematics is the science that deals with the logic of shape, quantity and arrangement.
      Math is all around us, in everything we do.
      It is the building block for everything in our daily lives,
      including mobile devices, computers, software, architecture (ancient and modern),
      art, money, engineering and even sports.
    </p>
  </div>
);

export default Home;
